import styled from 'styled-components';

const PressArticlesStyles = styled.section`
  .articles {
    display: grid;
    gap: 2rem;
    grid-template-columns: 1fr 1fr;
    margin: 0;
    padding: 0;
    list-style: none;

    .article,
    .article .link,
    .article > div {
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .article {
      position: relative;
      aspect-ratio: 1/1;
      background-color: var(--color-sand);
      text-align: center;

      .link {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;

        > div {
          font-size: 0;
          line-height: 1;
        }
      }

      .image {
        width: 70%;
        transition: transform 0.4s;
      }

      &:hover,
      &:focus {
        .image {
          transform: scale(1.1);
        }
      }

      .inner-article {
        margin: 0 0 2.5rem;

        .headline {
          font-weight: var(--font-weight-light);
          text-transform: none;
        }

        &:last-child {
          margin: 0;
        }
      }
    }
  }

  @media (min-width: 768px) {
    .articles {
      grid-template-columns: 1fr 1fr 1fr;
    }
  }

  @media (min-width: 992px) {
    .articles {
      grid-template-columns: 1fr 1fr 1fr 1fr;
    }
  }

  @media (min-width: 1200px) {
    .articles {
      grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
    }
  }

  @media (min-width: 1500px) {
    .articles {
      grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
    }
  }
`;

export default PressArticlesStyles;
